import { useContext } from "react";
import { memo } from "react";
import { AppContext } from "../../../context/AppContext";
import ic_search_dark from "../../../assets/images/ic_search_dark.svg";
import searchicon from "../../../assets/images/ic_search.svg";


const HandleOperation = memo((props) => {

    const { Dark } = useContext(AppContext)

    const { setSearch, setCurrentPage, setPerPage, projectList, currentSelectedProject, setCurrentSelectedProject } = props

    return (
        <>
            <div className="role-table-header">
                <div className="search-input-wrapper">
                    <input
                        type="text"
                        placeholder="Search Project "
                        onChange={(e) => {
                            setSearch(e.target.value)
                            setCurrentPage(0);
                        }}
                    />
                    {Dark === "lightMode" ? (
                        <img src={searchicon} alt="" />
                    ) : (
                        <img src={ic_search_dark} alt="" />
                    )}
                </div>

                <div className="entries-wrapper">
                    <p>Entries per page</p>
                    <select
                        className="form-select select-drop-icon"
                        aria-label="Default select example"
                        onChange={(e) => {
                            setPerPage(Number(e.target.value));
                            setCurrentPage(0);
                        }}
                    >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="25" selected>
                            25
                        </option>
                    </select>
                </div>
                <div className="entries-wrapper">
                    <p>Select Projects</p>
                    <select
                        className="form-select select-drop-icon"
                        aria-label="Default select example"
                        value={currentSelectedProject}
                        onChange={(e) => {
                            setCurrentSelectedProject(e.target.value);
                            setCurrentPage(0);
                        }}
                    >
                        <option value={""}>Filtered bY Project Name</option>
                        {
                            projectList?.map((project) => {
                                return <option value={project}>{project}</option>
                            })
                        }


                    </select>
                </div>
            </div>
        </>

    )

})

export default HandleOperation